import React, { useState, useEffect } from 'react';

const phrases = [
  "Conectando você...",
  "Comodidade Sempre...",
  "Tudo ao seu alcance...",
  "A melhor experiência...",
  "A melhor qualidade...",
  "A melhor comodidade...",
  "Tudo que você precisa...",
  "Na Hora que você precisa...",
  "Os Melhores negócios...",
  "Os Melhores serviços...",
  "Os Melhores produtos...",
  "Os Melhores profissionais...",
  "O cliente em primeiro lugar...",
  "O melhor atendimento...",
  "O melhor preço...",
  "O melhor serviço...",
  "Conectando a Cidade..."
];

const getRandomIndex = () => Math.floor(Math.random() * phrases.length);

const LoadingSpinner: React.FC = () => {
  const [currentPhrase, setCurrentPhrase] = useState(phrases[getRandomIndex()]);
  const [lastPhraseIndex, setLastPhraseIndex] = useState(getRandomIndex());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Minimum loading time of 2 seconds
    const minimumLoadingTime = new Promise(resolve => setTimeout(resolve, 2000));
    
    // Wait for both the minimum time and any other loading operations
    Promise.all([minimumLoadingTime])
      .then(() => {
        setIsLoading(false);
      });

    const interval = setInterval(() => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * phrases.length);
      } while (newIndex === lastPhraseIndex && phrases.length > 1);
      
      setLastPhraseIndex(newIndex);
      setCurrentPhrase(phrases[newIndex]);
    }, 3000);

    return () => clearInterval(interval);
  }, [lastPhraseIndex]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center space-y-6">
      <img 
        src="/logo.png" 
        alt="Logo" 
        className="w-32 h-32 object-contain"
      />
      <p className="text-lg text-gray-600 animate-fade-in-out text-center max-w-md">
        {currentPhrase}
      </p>
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary"></div>
    </div>
  );
};

export default LoadingSpinner; 
